import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const FinalCTA = ({ onQuoteClick }) => {
  return (
    <section
      data-testid="final-cta"
      className="relative overflow-hidden bg-[#13294B] text-white"
    >
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=2000&q=80)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B1A33] via-[#0B1A33]/85 to-[#13294B]/70" />

      <div className="relative container mx-auto px-6 lg:px-12 max-w-7xl py-24 lg:py-32">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.22em] text-white/55 font-medium">
            Let's build together
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[56px] font-extrabold leading-[1.05] tracking-tight mt-5">
            Let's Build Something
            <br />
            <span className="text-white/70">Exceptional.</span>
          </h2>
          <p className="mt-6 text-white/70 text-lg max-w-xl leading-relaxed">
            Whether you're planning a complete renovation, furnishing a holiday
            home or looking for a reliable maintenance partner, our team is
            ready to help.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={onQuoteClick}
              data-testid="cta-request-quote"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#13294B] hover:bg-white/90 rounded-full px-7 py-4 text-[15px] font-medium transition"
            >
              Request Quotation <ArrowRight size={16} />
            </button>
            <a
              href={BRAND.phoneHref}
              data-testid="cta-call"
              className="inline-flex items-center justify-center gap-2 border border-white/25 hover:bg-white/10 rounded-full px-7 py-4 text-[15px] font-medium transition"
            >
              <Phone size={16} /> {BRAND.phone}
            </a>
            <a
              href={BRAND.whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebd5a] rounded-full px-7 py-4 text-[15px] font-medium transition"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
